import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-da43d838"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "wrapper"
};
const _hoisted_2 = {
  class: "block"
};
const _hoisted_3 = {
  class: "image-container"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "block"
};
const _hoisted_6 = {
  class: "info-container"
};

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h6", {
  class: "font-h6 title"
}, "Claim", -1));

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "font-caption2 desc"
}, " After you claim the NFT, it would no longer exist in your wallet. ", -1));

const _hoisted_9 = {
  class: "detail-wrapper"
};
const _hoisted_10 = {
  class: "row"
};
const _hoisted_11 = {
  class: "font-subtitle1 name"
};
const _hoisted_12 = {
  class: "row"
};

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font-caption2 title"
}, "Base Value", -1));

const _hoisted_14 = {
  class: "font-caption2 value"
};
const _hoisted_15 = {
  class: "row"
};

const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font-caption2 title"
}, "Reward", -1));

const _hoisted_17 = {
  class: "font-caption2 value"
};
const _hoisted_18 = {
  class: "row"
};

const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font-caption2 title"
}, "Contract Address", -1));

const _hoisted_20 = {
  class: "font-caption2 value"
};
const _hoisted_21 = {
  class: "btn-wrapper"
};
const _hoisted_22 = ["disabled"];
const _hoisted_23 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_common_modal = _resolveComponent("common-modal");

  return _openBlock(), _createBlock(_component_common_modal, {
    name: "claim"
  }, {
    content: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
      src: $props.detail?.image,
      alt: "image"
    }, null, 8, _hoisted_4)])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _hoisted_8, _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("span", _hoisted_11, _toDisplayString($props.detail.name), 1)]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("span", _hoisted_14, _toDisplayString(`${$props.detail.baseValue.amount} ${$props.detail.baseValue.token}`), 1)]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("span", _hoisted_17, _toDisplayString(`${$props.detail.reward.amount || "0"} ${$props.detail.reward.token}`), 1)]), _createElementVNode("div", _hoisted_18, [_hoisted_19, _createElementVNode("span", _hoisted_20, _toDisplayString($setup.briefAddress($props.detail.tokenAddress)), 1)])]), _createElementVNode("div", _hoisted_21, [$props.network !== $props.detail.chain ? (_openBlock(), _createElementBlock("button", {
      key: 0,
      class: "font-subtitle2 btn sm apply",
      disabled: _ctx.walletName === 'walletconnect',
      onClick: _cache[0] || (_cache[0] = (...args) => $options.changeNetwork && $options.changeNetwork(...args))
    }, _toDisplayString(`Switch Network ${_ctx.walletName === 'walletconnect' ? '(on mobile)' : ''}`), 9, _hoisted_22)) : (_openBlock(), _createElementBlock("button", {
      key: 1,
      class: "font-subtitle2 btn sm apply",
      onClick: _cache[1] || (_cache[1] = (...args) => $options.excute && $options.excute(...args)),
      disabled: $props.isPending || $props.isExcuting
    }, _toDisplayString(`${$props.isApproved ? "Claim" : "Approve"}${$props.isPending ? "..." : ""}`), 9, _hoisted_23))])])])])]),
    _: 1
  });
}